export default {
  //在线答疑
  chatStuList: '',
  chatDetail: '',
  chatReplayStu: '',
  chatDel: '',
  chatEdit: '',
}
